"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bug = void 0;
const types_1 = require("../../Shared/types");
const gotti_1 = require("gotti");
const Position_1 = require("../../Shared/Components/Position");
const Component_1 = require("../Systems/BugMovementAndAnimation/Component");
const Component_2 = require("../Systems/BugSpawn/Component");
const Component_3 = require("../Systems/ItemDrop/Component");
class Bug extends gotti_1.Entity {
    constructor(id, type) {
        super(id, types_1.EntityTypes.Bug);
        this.bugType = type;
    }
    initialize(data) {
        this.addComponent(new Position_1.Position(data.position.x, data.position.y));
        this.addComponent(new Component_2.BugSpawnComponent());
        this.addComponent(new Component_1.BugMovementComponent(data.frames));
        this.addComponent(new Component_3.ItemDropComponent('', ''));
    }
}
exports.Bug = Bug;
//# sourceMappingURL=module.js.map